var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "Content",
    { attrs: { id: "users" } },
    [
      _c(
        "div",
        { attrs: { slot: "search" }, slot: "search" },
        [
          _c(
            "Form",
            {
              attrs: { "label-width": 70, model: _vm.search, id: "searchForm" },
            },
            [
              _c(
                "Row",
                [
                  _c(
                    "Col",
                    [
                      _c(
                        "FormItem",
                        { attrs: { label: "结果词" } },
                        [
                          _c("Input", {
                            attrs: { maxlength: "50" },
                            model: {
                              value: _vm.search.name,
                              callback: function ($$v) {
                                _vm.$set(_vm.search, "name", $$v)
                              },
                              expression: "search.name",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "Col",
                    [
                      _c(
                        "FormItem",
                        { attrs: { label: "状态" } },
                        [
                          _c(
                            "Select",
                            {
                              staticStyle: { "min-width": "75px" },
                              attrs: { clearable: true },
                              model: {
                                value: _vm.search.status,
                                callback: function ($$v) {
                                  _vm.$set(_vm.search, "status", $$v)
                                },
                                expression: "search.status",
                              },
                            },
                            _vm._l(_vm.statusList, function (item) {
                              return _c(
                                "Option",
                                {
                                  key: item.value,
                                  attrs: { value: item.value },
                                },
                                [_vm._v(_vm._s(item.label))]
                              )
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c("Col", [
                    _c(
                      "div",
                      { staticStyle: { display: "flex" } },
                      [
                        _vm._v("  "),
                        _c(
                          "Button",
                          {
                            attrs: { type: "primary" },
                            on: { click: _vm.query },
                          },
                          [_vm._v("查询")]
                        ),
                      ],
                      1
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticStyle: {
                "margin-bottom": "5px",
                display: "flex",
                width: "100%",
              },
              attrs: { slot: "extra" },
              slot: "extra",
            },
            [
              _c(
                "div",
                { staticStyle: { float: "left" } },
                [
                  _c(
                    "Button",
                    {
                      attrs: { size: "small", icon: "md-add", type: "primary" },
                      on: { click: _vm.handleCreate },
                    },
                    [_vm._v("添加")]
                  ),
                ],
                1
              ),
            ]
          ),
        ],
        1
      ),
      _c(
        "el-table",
        {
          ref: "singleTable",
          staticStyle: { width: "100%" },
          attrs: {
            data: _vm.dataList,
            "header-cell-style": {
              background: "#f8f8f9",
              color: "#515a6e",
              "text-align": "center",
            },
            "row-class-name": _vm.tableRowClassName,
            "highlight-current-row": "",
            "highlight-selection-row": "",
            "row-key": "id",
            "max-height": _vm.tableHeight,
          },
          on: { "row-click": _vm.selectrow },
        },
        [
          _c("el-table-column", {
            attrs: {
              fixed: "",
              align: "center",
              prop: "errorConfigName",
              label: "结果词",
              "min-width": "100",
            },
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              prop: "code",
              label: "编码",
              "min-width": "80",
            },
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              prop: "reason",
              label: "原因",
              "show-overflow-tooltip": "",
              "min-width": "80",
            },
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              prop: "propose",
              label: "建议",
              "show-overflow-tooltip": "",
              "min-width": "120",
            },
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              prop: "status",
              label: "状态",
              "min-width": "60",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _c("el-switch", {
                      attrs: { "active-value": 1, "inactive-value": 2 },
                      on: {
                        change: function ($event) {
                          return _vm.handleEditStatus(row, null, row.status)
                        },
                      },
                      model: {
                        value: row.status,
                        callback: function ($$v) {
                          _vm.$set(row, "status", $$v)
                        },
                        expression: "row.status",
                      },
                    }),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              prop: "operator",
              label: "最后操作人",
              "min-width": "150",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _c("div", [_vm._v(_vm._s(row.operatorAccount))]),
                    _c("div", [_vm._v(_vm._s(row.operator))]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              prop: "createTime",
              label: "最后操作时间",
              "min-width": "160",
            },
          }),
          _c("el-table-column", {
            attrs: {
              fixed: "right",
              align: "center",
              prop: "operation",
              label: "操作",
              "min-width": "150",
              id: "elPopoverVisible",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "text", size: "medium" },
                        on: {
                          click: function ($event) {
                            return _vm.handleEdit(row)
                          },
                        },
                      },
                      [_vm._v("编辑")]
                    ),
                    _c(
                      "el-popover",
                      {
                        attrs: { placement: "top", "min-width": "150" },
                        model: {
                          value: _vm.deleteVisible["visible_" + row.id],
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.deleteVisible,
                              "visible_" + row.id,
                              $$v
                            )
                          },
                          expression: "deleteVisible['visible_' + row.id]",
                        },
                      },
                      [
                        _c(
                          "p",
                          {
                            staticStyle: {
                              display: "flex",
                              "-webkit-box-align": "center",
                              "align-items": "center",
                              "line-height": "35px",
                              "font-size": "16px",
                            },
                          },
                          [
                            _c("i", {
                              staticClass: "el-popconfirm__icon el-icon-info",
                              staticStyle: { color: "red" },
                            }),
                            _vm._v("是否确定删除？\n          "),
                          ]
                        ),
                        _c(
                          "div",
                          {
                            staticStyle: {
                              "text-align": "right",
                              margin: "0",
                              "line-height": "30px",
                            },
                          },
                          [
                            _c(
                              "el-button",
                              {
                                staticStyle: {
                                  padding: "7px 15px",
                                  "font-size": "12px",
                                  "border-radius": "3px",
                                  background: "#FFFFFF",
                                  border: "1px solid #DCDFE6",
                                  color: "#606266",
                                },
                                attrs: { size: "small", type: "text" },
                                on: {
                                  click: function ($event) {
                                    return _vm.cancel(row)
                                  },
                                },
                              },
                              [_vm._v("取消")]
                            ),
                            _c(
                              "el-button",
                              {
                                attrs: { type: "primary", size: "small" },
                                on: {
                                  click: function ($event) {
                                    return _vm.del(row)
                                  },
                                },
                              },
                              [_vm._v("确定")]
                            ),
                          ],
                          1
                        ),
                        _c(
                          "a",
                          {
                            staticStyle: { color: "#409EFF" },
                            attrs: { slot: "reference" },
                            slot: "reference",
                          },
                          [_vm._v("删除")]
                        ),
                      ]
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c("Page", {
        staticStyle: { "margin-top": "10px" },
        attrs: {
          total: _vm.pageList.total,
          current: _vm.pageList.currentPage,
          "page-size": _vm.pageList.pageSize,
          "show-elevator": "",
          "show-sizer": "",
          "show-total": "",
          "page-size-opts": [10, 30, 50, 100],
        },
        on: {
          "on-change": _vm.chagecurrent,
          "on-page-size-change": _vm.chagepagesize,
        },
      }),
      _c(
        "Modal",
        {
          attrs: {
            width: "45%",
            title: _vm.windowTitle,
            styles: { top: "60px" },
            "mask-closable": false,
          },
          model: {
            value: _vm.editWindow,
            callback: function ($$v) {
              _vm.editWindow = $$v
            },
            expression: "editWindow",
          },
        },
        [
          _c("ResultWordEdit", {
            ref: "edit",
            style: { "overflow-y": "auto" },
            on: { "on-submit": _vm.handleSubmit },
          }),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "Button",
                {
                  on: {
                    click: function ($event) {
                      _vm.editWindow = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _c(
                "Button",
                { attrs: { type: "primary" }, on: { click: _vm.submit } },
                [_vm._v("确定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }